import axios from "axios";
let cache = null;

export async function fetchRatios() {
    if (cache) return cache;
  const { data } = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/screens_ratios`);
  console.log("Fetched Ratios:", data);
  const RATIOS = {};
  const LABELS = data?.data;
  const FIELD_ALIASES = {};
  const SUGGESTION = [];
  const LABELS_MAP = data?.categories || [];

  const OPERATORS = [">", "<", ">=", "<=", "=", "+", "-", "*", "/", "AND", "OR"];
  //LBL = data?.data;

  data?.data?.forEach(r => {
    RATIOS[r.slug] = r.slug;
    SUGGESTION.push(r.name);
    //LABELS[] = r;
    FIELD_ALIASES[r.name.toLowerCase()] = r.slug;

    /* r.aliases.forEach(alias => {
      FIELD_ALIASES[alias] = r.key_name;
    }); */
  });
  

  //console.log("Ratios===:", RATIOS, LABELS, FIELD_ALIASES);

  //return { RATIOS, LABELS, FIELD_ALIASES, OPERATORS };
  cache = { RATIOS, LABELS, FIELD_ALIASES, OPERATORS, SUGGESTION, LABELS_MAP };
  return cache;
}
/* 
export const RATIOS = {
  sales: "sales",
  roce: "roce",
  debt: "debt",
  market_cap: "market_cap",
  price_to_sales: "price_to_sales",
  sales_growth_3years: "sales_growth_3years",
  sales_growth_5years: "sales_growth_5years",
  pe: "pe",
};

export const LABELS = [
  "Sales",
  "ROCE",
  "Debt",
  "Market Capitalization",
  "Price to Sales",
  "Sales Growth 3Years",
  "Sales Growth 5Years",
  "Stock PE",
];

export const FIELD_ALIASES = {
  "sales": "sales",
  "roce": "roce",
  "debt": "debt",
  "market capitalization": "market_cap",
  "price to sales": "price_to_sales",
  "sales growth 3years": "sales_growth_3years",
  "sales growth 5years": "sales_growth_5years",
  "sales latest quarter": "sales_latest_quarter",
  "yoy quarterly sales growth": "yoy_quarterly_sales_growth",
  "stock pe": "pe",
};

export const OPERATORS = [">", "<", ">=", "<=", "=", "+", "-", "*", "/", "AND", "OR"];
  */